import React from "react";

const Footer = () => (
  <footer className="bg-light p-2 text-center">
    Acai Surveys by <a href="https://acaisoft.com">acaisoft</a>
  </footer>
);

export default Footer;
